import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState, useSyncExternalStore } from "react";
import {
  useDeleteEventHistoryMutation,
  useEventDropDownQuery,
  useGetProfilEventMutation,
  useUpdateEventMutation,
  useViewHistoryMutation,
} from "../../redux/candidateprofiles/candidateprofiles.api";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import WestIcon from "@mui/icons-material/West";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import DeleteIcon from "../../assets/deleteIcon.png";
import CloseIcon from "@mui/icons-material/Close";
import DisabledDeleteIcon from "../../assets/disabledDeleteIcon.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Dropdown from "../../reusable_components/components/Dropdown";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import Loader from "../../reusable_components/components/Loader";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import dayjs from "dayjs";
import CalendarIcon from "../../assets/Icons/CalendarIcon";


const ManageEventCandidate = () => {
  const location = useLocation();
  const { Snackbar } = useContext(SnackbarContext);
  const navigate = useNavigate();

  // get the values from other component
  const { profileId, firstName, lastName, email, mobile, isReferrals } =
    location?.state || "";
  const { Profile } = useSelector((state) => state.common);
  const role = Profile?.profile?.role;

  // for storing the table values
  const [profileEvents, setProfileEvents] = useState([]);
  const [ProFilePay, setProfilePay] = useState([]);
  // for sent payload
  const [changedRows, setChangedRows] = useState([]);
  const [showOverAllLoader, setShowOverAllLoader] = useState(false);

  const [dropdownEvent, setDropdownEvent] = useState([]);
  const [history, setHistory] = useState([]);
  const [isButton, setIsButton] = useState(false);
  const [showTableLoader, setShowTableLoader] = useState(false);

  // for capture the mainevent value
  const [mainEvent, setMainEvent] = useState();

  const [selectedEvents, setSelectedEvents] = useState([]); // Holds the selected values for each row
  const [remarks, setRemarks] = useState([]); // state for hold and capture the remarks
  const [positionId, setPositionId] = useState();

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setTotalPageCount] = useState(0);

  // API calllings
  const [profileEventsApi] = useGetProfilEventMutation();
  const { data: eventDropDown } = useEventDropDownQuery();
  const [update] = useUpdateEventMutation();
  const [viewHistoryDetails] = useViewHistoryMutation();
  const [deleteHistory] = useDeleteEventHistoryMutation();

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handlePageChange = (e, newValue) => {
    setPage(newValue);
  };

  const handleRowsPerpageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleChangeTentativeDate = (value, slicedIndex) => {
    const actualIndex = (page - 1) * rowsPerPage + slicedIndex;
    const formattedDate = value ? dayjs(value).format("YYYY-MM-DD") : null;
    const updatedEvents = [...profileEvents];
    updatedEvents[actualIndex] = {
      ...updatedEvents[actualIndex],
      tentativeJoiningDate: formattedDate,
    };
    setProfileEvents(updatedEvents);
    setChangedRows((prev) => new Set(prev).add(actualIndex));
  };

  const handleProfileSubmission = (item) => {
    const url = `/submitprofiles/${item?.positionId
      }?jobPostingName=${encodeURIComponent(item?.jobPostingName)}`;
    window.open(url, "_blank"); // opens in a new tab
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getEventProfiles = async () => {
    const eventId = +mainEvent;
    if (!eventId) {
      try {
        const payload = {
          eventTypeId: 0,
          profileId: profileId,
          page: page ? page - 1 : 0,
          size: 10000,
        };
        setShowTableLoader(true);
        const response = await profileEventsApi(payload).unwrap();
        setShowTableLoader(false);
        setProfileEvents(response?.response?.profileEvents);
        setTotalPageCount(response?.response?.count);
      } catch (error) {
        Snackbar("Network error", "error");
      } finally {
        setShowTableLoader(false);
      }
    } else {
      try {
        const payload = {
          eventTypeId: eventId,
          page: page ? page - 1 : 0,
          profileId: profileId,
          size: rowsPerPage ? rowsPerPage : 100,
        };
        const response = await profileEventsApi(payload).unwrap();
        setProfileEvents(response?.response?.profileEvents);
        setTotalPageCount(response?.response?.count);
      } catch (error) {
        Snackbar("Network error", "error");
      }
    }
  };

  const handleEvent = (e) => {
    setMainEvent(e);
    setPage(1);
  };

  // this is for capture the eventTypeId
  const handleDropdown = (e, slicedIndex) => {
    const actualIndex = (page - 1) * rowsPerPage + slicedIndex;
    const value = e;
    const updatedEvent = [...profileEvents];
    updatedEvent[actualIndex] = {
      ...updatedEvent[actualIndex],
      eventTypeId: value,
    };
    setProfileEvents(updatedEvent);
    setChangedRows((prev) => new Set(prev).add(actualIndex));
  };

  // this is for capture the  comment
  const handleTextField = (e, slicedIndex) => {
    const actualIndex = (page - 1) * rowsPerPage + slicedIndex;
    const value = e.target.value;
    const updatedRemarks = [...profileEvents];
    updatedRemarks[actualIndex] = {
      ...updatedRemarks[actualIndex],
      remarks: value,
    };
    setProfileEvents(updatedRemarks);
    setChangedRows((prev) => new Set(prev).add(actualIndex));
  };

  const [eventOptions, setEventOptions] = useState([]);

  useEffect(() => {
    getEventProfiles();
  }, []);

  useEffect(() => {
    setProfilePay(profileEvents);
  }, [profileEvents, getEventProfiles]);

  useEffect(() => {
    getEventProfiles();
    setDropdownEvent(eventDropDown?.response);
    setEventOptions(eventDropDown?.response);
  }, [eventDropDown, dropdownEvent, mainEvent]);

  const handleSubmit = async () => {
    try {
      const modifiedRows = Array.from(changedRows).map((index) => {
        const { profileMatchId, eventTypeId, remarks, tentativeJoiningDate } = profileEvents[index];
        return {
          profileMatchId,
          eventTypeId,
          comment: remarks, // Map remarks to comment
          tentativeJoiningDate: tentativeJoiningDate ? dayjs(tentativeJoiningDate).format("DD-MM-YYYY") : null
        };
      });

      const payload = {
        values: modifiedRows,
      }; // Only send modified rows

      if (profileEvents?.length > 0) {
        setShowOverAllLoader(true);
        const response = await update(payload).unwrap();
        setShowOverAllLoader(false);
        Snackbar(response?.response?.Message, "success");
        getEventProfiles();
      }
    } catch (error) {
      Snackbar("Network Error", "error");
    }
  };

  const viewHistory = async (item) => {
    setOpen(true);
    try {
      const payload = {
        page: 0,
        positionId: item?.positionId,
        profileId: profileId,
        size: 5000,
      };
      const response = await viewHistoryDetails(payload).unwrap();
      setHistory(response?.response?.eventHistory);
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const [MinihistoryDialogOpen, setMinihistoryDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState([]);
  const [profileMatchId, setProfileMatchId] = useState();
  const [isDelete, setIsDelete] = useState(false);

  const handleCloseDelete = () => {
    setMinihistoryDialogOpen(false);
  };

  const hanldeMiniDialogOpen = (item) => {
    setMinihistoryDialogOpen(true);
    setProfileMatchId(item?.profileMatchId);
    setDeleteId(item?.eventHistoryId);
    setIsDelete(item?.deletable);
  };

  const deleteEventHistory = async (item) => {
    if (isDelete === true) {
      try {
        const payload = {
          eventHistoryIds: [deleteId] || [],
          profileMatchId: profileMatchId, // Use 0 as default if profileMatchId is missing
        };

        const response = await deleteHistory(payload).unwrap();
        setMinihistoryDialogOpen(false);
        setOpen(false);
        Snackbar(response?.response?.message, "success");
      } catch (error) {
        Snackbar("Network error", "error");
      }
    }
  };

  useEffect(() => {
    if (role === "recruiter") {
      setIsButton(true);
    }
  }, []);

  const formatDate = (date = new Date()) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleBack = () => {
    navigate("/candidateprofile");
  };

  const handleNavigation = () => {
    // if (isReferrals === true) {
    //     navigate('/referrals')
    // } else {
    //     navigate('/candidateprofile')
    // }
    navigate(-1);
  };

  return (
    <Box className="container">
      {showOverAllLoader ? <Loader /> : ""}
      <Grid2
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#6941C6",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
          marginBottom: "20px",
        }}
        onClick={handleNavigation}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Back</Typography>
      </Grid2>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignContent: "start" }}>
          <Typography className="title"> Manage Events-Candidate </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: "14px" }}>
            <span className="title">{firstName}</span>
            <span className="title">{" " + lastName}</span>
            <br></br>
            <span style={{ color: "#53389E", fontWeight: 600 }}>
              {email}
              <br></br>
              {mobile}
            </span>
          </Typography>
        </Box>
      </Box>
      <Grid2
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        {/* profileId--name--email--mobile */}
        {/* <Grid2>
                    <Typography sx={{ fontSize: '14px' }} >Profile ID :<span style={{ fontWeight: 'bold' }}> {profileId}</span></Typography>
                    <Typography sx={{ fontSize: '14px' }} >First Name: <span style={{ fontWeight: 'bold' }}> {firstName}</span></Typography>
                    <Typography sx={{ fontSize: '14px' }} >LastName:   <span style={{ fontWeight: 'bold' }}> {lastName}</span></Typography>
                    <Typography sx={{ fontSize: '14px' }} >Email:      <span style={{ fontWeight: 'bold' }}> {email}</span></Typography>
                    <Typography sx={{ fontSize: '14px' }} >Mobile:     <span style={{ fontWeight: 'bold' }}> {mobile}</span></Typography>
                </Grid2> */}
      </Grid2>

      {/* table container */}
      <Grid2 sx={{ marginBottom: "50px" }}>
        <Paper
          sx={{
            width: "100%",
            overflow: "auto",
            marginTop: "10px",
            border: "1px solid #E9EAEB",
          }}
          elevation={0}
        >
          <Table sx={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell colSpan={10}>
                  <Grid2>
                    <Dropdown
                      placeholder="Select an event"
                      displayEmpty
                      options={eventOptions || []}
                      valueKey="eventTypeId"
                      labelKey="event"
                      value={mainEvent}
                      onChange={handleEvent}
                      sx={{
                        height: "35px",
                        width: "250px",
                        fontSize: "14px",

                        "& .MuiInputBase-root": {
                          fontSize: "14px", // Apply font size to input
                        },
                      }}
                    />
                  </Grid2>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="tableHeadersCell">
                  {" "}
                  Client Name{" "}
                </TableCell>
                <TableCell className="tableHeadersCell">
                  {" "}
                  Job Position Name{" "}
                </TableCell>
                <TableCell className="tableHeadersCell" sx={{ width: "11%" }}>
                  {" "}
                  Position Status
                </TableCell>
                <TableCell className="tableHeadersCell">
                  {" "}
                  Select Event{" "}
                </TableCell>
                <TableCell className="tableHeadersCell"> Remarks </TableCell>
                <TableCell className="tableHeadersCell">Action</TableCell>
              </TableRow>
            </TableHead>

            {!showTableLoader ? (
              profileEvents?.length > 0 ? (
                <TableBody>
                  {profileEvents
                    ?.slice((page - 1) * rowsPerPage, page * rowsPerPage)
                    ?.map((item, index) => (
                      <TableRow
                        hover
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#FAFAFA" : "inherit",
                          "&:hover": { backgroundColor: "#f1f1f1" },
                        }}
                      >
                        <TableCell
                          className="tableBodyCell"
                          disabled={item?.positionStatus === "Closed"}
                        >
                          {item?.clientName}
                        </TableCell>
                        <TableCell
                          className="tableBodyCell"
                          disabled={item?.positionStatus !== "Active"}
                          sx={{
                            color: "#6941C6",
                            cursor: "pointer",
                            width: "15%",
                            fontWeight: 550,
                          }}
                          onClick={() => handleProfileSubmission(item)}
                        >
                          {item?.jobPostingName}
                        </TableCell>
                        <TableCell className="tableBodyCell">
                          <span
                            className={`jobStatus-badge ${item?.positionStatus
                              ?.toLowerCase()
                              ?.replace(/\s+/g, "-")}`}
                          >
                            {" "}
                            {item.positionStatus}
                          </span>
                        </TableCell>
                        {
                          <Tooltip title={item?.positionStatus !== "Active" && "This position is closed, so we can’t edit it."} arrow>
                            <TableCell className="tableBodyCell">
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'nowrap' }}>
                                <Box sx={{ flex: 1, minWidth: '150px' }}>
                                  <Dropdown
                                    placeholder="Enter remarks"
                                    displayEmpty
                                    options={dropdownEvent || []}
                                    disabled={item?.positionStatus !== "Active"}
                                    valueKey="eventTypeId"
                                    labelKey="event"
                                    value={item?.eventTypeId || ""}
                                    onChange={(e) => handleDropdown(e, index)}
                                    sx={{
                                      height: "35px",
                                      width: "100%",
                                      fontSize: "14px",

                                      "& .MuiInputBase-root": {
                                        fontSize: "14px", // Apply font size to input
                                      },
                                    }}
                                  />
                                </Box>
                                {
                                  item?.eventTypeId === 9 && (
                                    <Box sx={{
                                      flexShrink: 0,
                                      width: '150px'
                                    }}>
                                      <MuiDatePicker
                                        slots={{
                                          openPickerIcon: CalendarIcon,
                                        }}
                                        value={
                                          item?.tentativeJoiningDate
                                            ? dayjs(item.tentativeJoiningDate)
                                            : null
                                        }
                                        onChange={(value) => handleChangeTentativeDate(value, index)}
                                        format="DD-MM-YYYY"
                                        minDate={dayjs()}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            placeholder: "DD-MM-YYYY",
                                            InputProps: {
                                              sx: {
                                                borderRadius: "10px",
                                                height: "35px",
                                                width: '100%',
                                                fontSize: '13px'
                                              },
                                            },
                                          },
                                        }}
                                        sx={{
                                          width: '100%',
                                          "& .MuiInputBase-input": {
                                            fontSize: "13px",
                                            padding: '8px 12px',
                                            height: 'auto',
                                          },
                                          "& .MuiSvgIcon-root": {
                                            fontSize: "18px",
                                          },
                                        }}
                                      />
                                    </Box>
                                  )
                                }
                              </Box>
                            </TableCell></Tooltip>
                        }
                        <TableCell className="tableBodyCell">
                          <textarea
                            className="jobPostingTextAreas"
                            disabled={item?.positionStatus !== "Active"}
                            style={{
                              width: "90%",
                              resize: "none",
                              borderRadius: "7px",
                              color: "#535862",
                            }}
                            value={item?.remarks}
                            onChange={(e) => handleTextField(e, index)}
                            placeholder="Enter Remarks"
                          />
                        </TableCell>
                        <TableCell className="tableBodyCell">
                          <Typography
                            onClick={(e) => viewHistory(item)}
                            style={{
                              fontSize: "13px",
                              color: "#6941C6",
                              width: "100%",
                              cursor: "pointer",
                              fontWeight: 700,
                            }}
                            disabled={item?.positionStatus === "Closed"}
                          >
                            View History
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={8}>
                      <Typography className="emptydatas">
                        No Data Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )
            ) : (
              <TableRow>
                <TableCell colSpan={13}>
                  <Box className="tableloader">
                    <TableLoader />
                  </Box>
                </TableCell>
              </TableRow>
            )}

            <TableRow>
              {count <= rowsPerPage ? (
                ""
              ) : (
                <TableCell colSpan={100}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <MUICancelButton
                      title="Previous"
                      startIcon={
                        <ArrowBackIcon
                          sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }}
                        />
                      }
                      disabled={page === 1}
                      onClick={() => handleChangePage(null, page - 1)}
                      sx={{ height: "36px" }}
                    />
                    <Pagination
                      page={page}
                      onChange={handleChangePage}
                      count={Math.ceil(count / rowsPerPage)}
                      siblingCount={3}
                      boundaryCount={3}
                      shape="rounded"
                      hidePrevButton
                      hideNextButton
                    />

                    <MUICancelButton
                      title="Next"
                      startIcon={
                        <ArrowForwardIcon
                          sx={{
                            color:
                              page === Math.ceil(count / rowsPerPage)
                                ? "#a2a2a2"
                                : "#414651",
                          }}
                        />
                      }
                      disabled={page === Math.ceil(count / rowsPerPage)}
                      onClick={() => handleChangePage(null, page + 1)}
                      sx={{ height: "36px" }}
                    />
                  </div>
                </TableCell>
              )}
            </TableRow>
          </Table>
        </Paper>
      </Grid2>

      <Grid2
        item
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          marginTop: "15px",
          borderTop: "1px solid #D5D7DA",
          padding: "20px",
        }}
      >
        {isButton ? (
          <MUICancelButton
            title="Cancel"
            component={Link}
            to={isReferrals ? "/referrals" : "/candidateprofile"}
          />
        ) : (
          <Box sx={{ display: "flex", gap: "30px" }}>
            <MUICancelButton
              title="Cancel"
              component={Link}
              to={isReferrals ? "/referrals" : "/candidateprofile"}
            />
            <MUICancelButton
              title="Save Changes"
              sx={{
                backgroundColor: "#7F56D9",
                color: "white",
                width: "130px",
              }}
              onClick={handleSubmit}
            />
          </Box>
        )}
      </Grid2>

      <Grid2></Grid2>
      {/* Add job dialog box */}
      <Grid2>
        <Dialog
          open={open}
          onClose={handleClose}
          scroll="paper"
          maxWidth="md"
          sx={{
            "& .MuiDialog-paper": {
              minHeight: "85vh",
              minWidth: "70vw",
            },
            marginLeft: "70px",
          }}
        >
          <DialogTitle variant="h6">
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography className="title">History</Typography>
              <CloseIcon
                sx={{ cursor: "pointer" }}
                onClick={handleClose}
              ></CloseIcon>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="tableHeadersCell">Date </TableCell>
                    <TableCell className="tableHeadersCell">
                      Client Name{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">
                      Job Title{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">Event </TableCell>
                    <TableCell className="tableHeadersCell">Notes </TableCell>
                    <TableCell className="tableHeadersCell">
                      Processed By{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">Action</TableCell>
                  </TableRow>
                </TableHead>
                {history?.length > 0 ? (
                  <TableBody>
                    {history?.map((item, index) => {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell className="tableBodyCell">
                            {formatDate(item?.date)}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.clientName}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.jobTitile}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.event}
                          </TableCell>

                          <TableCell className="tableBodyCell">
                            {item.notes === null ? "-" : item?.notes}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.processedBy}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            <Tooltip
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#0A0D12",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                  },
                                },
                              }}
                              title={item?.deletable ? "Delete" : ""}
                            >
                              <IconButton
                                sx={{ color: item?.deletable && "#fd5c63" }}
                                disabled={!item?.deletable}
                                onClick={(e) =>
                                  item?.deletable && hanldeMiniDialogOpen(item)
                                }
                              >
                                <img
                                  src={
                                    item?.deletable
                                      ? DeleteIcon
                                      : DisabledDeleteIcon
                                  }
                                  style={{
                                    cursor: !item?.deletable && "not-allowed",
                                    pointerEvents: "auto",
                                    height: "17px",
                                    width: "17px",
                                  }}
                                  alt="delete icon"
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Typography className="emptydatas">
                          No Data Found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <MUICancelButton
              onClick={handleClose}
              title="Close"
            ></MUICancelButton>
          </DialogActions>
        </Dialog>

        <Grid2 item>
          <Dialog
            open={MinihistoryDialogOpen}
            scroll="paper"
            maxWidth="xs"
            sx={{
              "& .MuiDialog-paper": {
                width: "90%",
                maxWidth: "550px",
                height: "auto",
                borderRadius: "15px",
              },
            }}
          >
            <DialogContent>
              <DialogContentText>
                <div style={{ display: "flex", gap: "12px", marginTop: "7px" }}>
                  <div
                    style={{
                      backgroundColor: "#FEE4E2",
                      borderRadius: "40px",
                      height: "40px",
                      width: "45px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={DeleteIcon}
                      style={{ width: "20px", height: "20px" }}
                    />
                  </div>

                  <div>
                    <Typography
                      sx={{
                        color: "#181D27",
                        fontWeight: 600,
                        fontSize: "17px",
                      }}
                    >
                      Delete Job?
                    </Typography>
                    <Typography
                      sx={{
                        color: "#535862",
                        fontWeight: 400,
                        fontSize: "14px",
                      }}
                    >
                      Are you sure you want to delete this post? This action
                      cannot be undone.
                    </Typography>
                  </div>
                </div>
                <Grid2
                  item
                  sx={{
                    marginTop: "25px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                  }}
                >
                  <MUICancelButton
                    title="Cancel"
                    onClick={() => setMinihistoryDialogOpen(false)}
                  />
                  <MUIButton
                    title="Delete"
                    sx={{
                      backgroundColor: "#D92D20",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={deleteEventHistory}
                  />
                </Grid2>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Grid2>
      </Grid2>
    </Box>
  );
};
export default ManageEventCandidate;
